import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('SERIES_INFO', {
  FETCH_SAME_SERIES_REQUEST: null,
  FETCH_SAME_SERIES_SUCCESS: null,
  FETCH_SAME_SERIES_FAILURE: null
});
